import React from 'react';
import debounce from 'lodash/debounce';

type Options = Parameters<typeof debounce>[2];

export const useDebounceCallback = (
  cb: (...args: Array<any>) => void,
  deps: Array<any> = [],
  delay = 500,
  options?: Options,
) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useCallback(debounce(cb, delay, options), [delay, options, ...deps]);
